import { MembershipProfileTag as MembershipProfileTagModel } from '@models/membership/MembershipProfileTag'
import { useAppSelector } from '@store/hooks'
import { selectMembershipProfileTagById } from '@store/membership/MembershipProfileTagReducer'
import { SBIcon } from '@supplement-bacon/react-toolkit/components'
import { SBModelComponent } from '@supplement-bacon/react-toolkit/models'
import { Tag as ANTDTag, Typography } from 'antd'
import { FC } from 'react'

const { Title } = Typography

type Props = SBModelComponent<MembershipProfileTagModel> & {
  size?: 'small' | 'large'
}

const Tag: FC<Props> = ({ id, model, size = 'small' }) => {
  const item = model
    ? model
    : useAppSelector(selectMembershipProfileTagById(id!))

  if (!item) {
    return <></>
  }

  if (size === 'small')
    return (
      <ANTDTag color={item.color} icon={<SBIcon name={item.icon} />}>
        {item.name}
      </ANTDTag>
    )

  return (
    <ANTDTag color={item.color} icon={<SBIcon name={item.icon} />}>
      <Title className="m-0" level={5} style={{ color: 'unset' }}>
        {item.name}
      </Title>
    </ANTDTag>
  )
}

type MembershipProfileTagType = { Tag: typeof Tag }

export { Tag, type MembershipProfileTagType }
